<template>
    <div class="flex flex-col justify-center space-y-32">
        <div class="w-full">
            <created-vacancies
                ref="createdVacanciesGraph"
                :filterFields="filterFields"
                :class="defaultCardClasses"
            />
        </div>
        <div class="w-full">
            <active-vacancies
                ref="activeVacanciesGraph"
                :filterFields="filterFields"
                :class="defaultCardClasses"
            />
        </div>
        <div class="w-full">
            <hired-candidates
                ref="hiredCandidatesGraph"
                :filterFields="filterFields"
                :class="defaultCardClasses"
            />
        </div>
    </div>
</template>

<script>
// apexcharts imports
import ActiveVacancies from "./ActiveVacancies.vue";
import CreatedVacancies from "./CreatedVacancies.vue";
import HiredCandidates from "./HiredCandidates.vue";

export default {
    name: 'TabVacancies',
    components: {
        ActiveVacancies,
        CreatedVacancies,
        HiredCandidates,
        // Add chart components here
    },
    props: {
        filterFields: {type: Object},
        defaultCardClasses: {type: String},
    },
}
</script>

<style scoped>
    .small-block {
        width: 49%;
    }
</style>
